<template>
  <Details v-if="section === 'details'" :product="product" />
  <Documents v-if="section === 'documents' && !inDepth" />
</template>

<script>
import Details from "../../components/productdetails/Details";
import Documents from "../../components/productdetails/Documents";
import urls from "@/urls";
import messages from "@/messages";

export default {
  name: "ProductsDetail",

  components: {
    Details,
    Documents,
  },

  data() {
    return {
      initSection: "details",
      product: {},
    };
  },

  computed: {
    section() {
      if (this.$route.meta && this.$route.meta.section) {
        return this.$route.meta.section;
      }
      return this.initSection;
    },

    inDepth() {
      return !!this.product.inDepth?.length;
    },
  },

  methods: {
    async fetchProduct() {
      try {
        const instance = await this.$http({
          method: "GET",
          url: urls.products.product + "/" + this.$route.params.id + "/details",
          params: {},
        });
        console.log("istanza", instance);
        this.product = instance;
        setTimeout(() => {
          this.cleanParagraphs();
        }, 500);
        this.$matomo.logPage(instance.name + " (Product details)");
      } catch (e) {
        console.error(e);
        this.$toast({
          message: messages.errors.productDetail,
          color: "danger",
        });
      }
    },
  },

  async created() {
    if (this.$route.params.id) {
      this.fetchProduct();
    } else {
      console.error("No product id in route");
      this.$toast({
        message: messages.errors.productDetail,
        color: "danger",
      });
      this.$router.back();
    }
  },
  watch: {
    "$route.params.id"() {
      this.fetchProduct();
    },
  },
};
</script>
